import { Settings, FileText, Sun } from "lucide-react";

const steps = [
  {
    icon: Settings,
    number: "01",
    title: "Configura",
    description: "Compila il modulo con le tue preferenze: tipo di immobile, consumo energetico e zona geografica.",
    color: "bg-emerald-50 text-emerald-600",
  },
  {
    icon: FileText,
    number: "02",
    title: "Ricevi Proposte",
    description: "I fornitori della tua zona competono per offrirti il miglior preventivo personalizzato.",
    color: "bg-blue-50 text-blue-600",
  },
  {
    icon: Sun,
    number: "03",
    title: "Scegli e Risparmia",
    description: "Confronta le offerte ricevute e scegli quella perfetta per te. Senza alcun obbligo.",
    color: "bg-amber-50 text-amber-600",
  },
];

export const HowItWorks = () => {
  return (
    <section id="come-funziona" className="py-20 sm:py-28 bg-white" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left max-w-xl mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">Come Funziona</span>
          <h2
            className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="how-it-works-title"
          >
            Tre semplici passi verso<br />l'energia solare
          </h2>
          <p className="mt-4 text-slate-500 text-base sm:text-lg">
            Il nostro servizio rende semplice e veloce trovare la soluzione fotovoltaica ideale per te.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className="relative group animate-fade-in-up"
              style={{ animationDelay: `${i * 150}ms` }}
              data-testid={`step-card-${step.number}`}
            >
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-full w-full h-px bg-slate-200 -translate-x-1/2 z-0" />
              )}
              <div className="relative bg-white rounded-2xl border border-slate-100 p-8 hover:border-emerald-500/40 transition-colors duration-300 hover:shadow-lg">
                <div className={`w-14 h-14 rounded-xl ${step.color} flex items-center justify-center mb-6`}>
                  <step.icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <span className="text-xs font-bold text-slate-300 tracking-widest uppercase">Passo {step.number}</span>
                <h3 className="mt-2 text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
                  {step.title}
                </h3>
                <p className="mt-3 text-slate-500 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
